export enum SessionNoteAccess {
    Public = 'public',
    Private = 'private'
}

export type SessionNote = {
    id: string;
    authorEid: number;
    access: SessionNoteAccess;
    message: string;
}